module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.size
  }, [_c('div', {
    staticClass: "crowd-box-specialist",
    class: _vm.getBgdColor()
  }, [_c('div', {
    staticClass: "crowd-box-photo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.specialist.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.specialist.photo.thumb.url) ? _c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.specialist.photo.thumb.url
    }
  }) : _c('img', {
    attrs: {
      "src": require("assets/img/specialist.jpg")
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "crowd-box-text"
  }, [_c('p', [_c('router-link', {
    staticClass: "hire",
    attrs: {
      "to": {
        name: 'profiles'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("specialist.header")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "name",
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.specialist.id
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.specialist.full_name) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.specialist.profession) ? _c('router-link', {
    staticClass: "specialisation",
    attrs: {
      "to": {
        name: 'profiles',
        query: {
          specialisation: _vm.specialist.profession.name
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.specialist.profession.name) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "short-skills"
  }, [_vm._v(_vm._s(_vm.specialist.short_description))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-428eb953"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Tiles/Specialist.vue
// module id = 802
// module chunks = 1